import { fetchSSBUCharacters } from "./ssbu.apis"

const state = {
  characters: null,
}

const mutations = {
  UPDATE_CHARACTERS: (state, characters) => {
    state.characters = characters
  },
}

const actions = {
  async loadCharacters ({ state, commit }) {
    if (state.characters !== null) {
      return
    }
    const characters = await fetchSSBUCharacters()
    commit("UPDATE_CHARACTERS", characters)
  },
}

const getters = {
  getCharacters: state => state.characters || {},
  getCharacterByName: state => characterName => {
    return Object.values(state.characters || {})
      .find(({ name }) => name === characterName)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/game/ssbu/ssbu.module.js